import { createSelector } from 'reselect';
import type { RootState } from 'typesafe-actions';

import type { ReservationEntranceState } from './reducer';

export const getItems = (state: RootState) => state.reservationEntrance.items;
export const getErrors = (state: RootState) => state.reservationEntrance.errors;

export const getReservationEntrance = (state: RootState) => state.reservationEntrance;

// XXX: Update to your own implementation of computed state
export const getIsFetching = createSelector(
  getReservationEntrance,
  (state: ReservationEntranceState) => state.isFetching,
);
